module.exports = {"150921106":"卓资山镇","150921107":"旗下营镇","150921108":"十八台镇","150921109":"巴音锡勒镇","150921110":"梨花镇","150921210":"大榆树乡","150921211":"红召乡","150921212":"复兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150921.json
// module id = 555
// module chunks = 0